import MuiCssBaseline from "./MuiCssBaseline";
import MuiButton from "./MuiButton";
import MuiTextField from "./MuiTextField";
import MuiSelect from "./MuiSelect";
import MuiInputLabel from "./MuiInputLabel";
import MuiFormControlLabel from "./MuiFormControlLabel";
import MuiAlert from "./MuiAlert";
import MuiChip from "./MuiChip";
import MuiDivider from "./MuiDivider";

const components = {
  MuiCssBaseline,
  MuiButton,
  MuiChip,
  MuiTextField,
  MuiSelect,
  MuiInputLabel,
  MuiFormControlLabel,
  MuiAlert,
  MuiDivider,
};

export default components;
